export const iconFontAwesomeMapsMountainSun = (
	<i className="fa-solid fa-mountain-sun"></i>
);
